module.exports = __webpack_public_path__ + "static/img/Mission.0826a7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Mission.png
// module id = 3Btl
// module chunks = 1